import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FiArrowUpRight } from 'react-icons/fi';

const appear = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 18px, 0) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
`;

const pulse = keyframes`
  0%, 100% {
    box-shadow:
      0 16px 42px rgba(20, 44, 79, 0.22),
      0 0 0 0 rgba(79, 141, 255, 0);
  }
  50% {
    box-shadow:
      0 18px 48px rgba(20, 44, 79, 0.28),
      0 0 0 7px rgba(79, 141, 255, 0.1);
  }
`;

const FloatingApplicationLink = styled.a`
  position: fixed;
  z-index: 2999;
  bottom: 2rem;
  left: 2rem;
  display: grid;
  grid-template-columns: auto 32px;
  grid-template-areas:
    "status icon"
    "label icon";
  align-items: center;
  min-width: 190px;
  min-height: 66px;
  padding: 10px 12px 10px 17px;
  overflow: hidden;
  border: 1px solid rgba(150, 195, 255, 0.32);
  border-radius: 20px;
  background:
    linear-gradient(145deg, rgba(19, 27, 40, 0.98), rgba(29, 48, 73, 0.96));
  color: #fff !important;
  text-decoration: none;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  isolation: isolate;
  animation:
    ${appear} 620ms cubic-bezier(0.22, 1, 0.36, 1) both,
    ${pulse} 3.8s 1s ease-in-out infinite;
  transition:
    transform 240ms cubic-bezier(0.22, 1, 0.36, 1),
    border-color 240ms ease,
    box-shadow 240ms ease;

  &::before {
    content: "";
    position: absolute;
    z-index: -1;
    inset: 0;
    background:
      radial-gradient(circle at 82% 20%, rgba(108, 174, 255, 0.3), transparent 38%);
    pointer-events: none;
  }

  &:hover {
    color: #fff !important;
    text-decoration: none;
    border-color: rgba(169, 211, 255, 0.58);
    transform: translateY(-4px);
    box-shadow:
      0 22px 54px rgba(20, 44, 79, 0.34),
      0 0 0 7px rgba(79, 141, 255, 0.1);
  }

  &:focus-visible {
    outline: 3px solid rgba(74, 136, 255, 0.32);
    outline-offset: 4px;
  }

  .apple-application-float__status {
    grid-area: status;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: #9fc9ff;
    font-size: 10px;
    font-weight: 850;
    letter-spacing: 0.08em;
  }

  .apple-application-float__status::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #79c3ff;
    box-shadow: 0 0 0 5px rgba(121, 195, 255, 0.11);
  }

  strong {
    grid-area: label;
    margin-top: 2px;
    font-size: 15px;
    font-weight: 780;
    letter-spacing: -0.025em;
  }

  svg {
    grid-area: icon;
    width: 32px;
    height: 32px;
    padding: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
    transition: transform 220ms ease, background-color 220ms ease;
  }

  &:hover svg {
    background: rgba(255, 255, 255, 0.18);
    transform: translate(2px, -2px);
  }

  @media (max-width: 768px) {
    bottom: 1rem;
    left: 1rem;
    min-width: 174px;
    min-height: 58px;
    padding: 8px 10px 8px 14px;
    border-radius: 17px;

    strong {
      font-size: 14px;
    }

    svg {
      width: 30px;
      height: 30px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const HomeApplicationFloatingButton = () => (
  <FloatingApplicationLink
    href="https://narnia-lab.com/apply/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="기간 한정 서비스 신청하기"
  >
    <span className="apple-application-float__status">기간 한정</span>
    <strong>서비스 신청하기</strong>
    <FiArrowUpRight aria-hidden="true" />
  </FloatingApplicationLink>
);

export default HomeApplicationFloatingButton;
